// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3MLrW","searchIcon":"searchIcon___1LIsd","suggestionsList":"suggestionsList___kLH2N","loading":"loading___3jp8c"};